import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/masterdata-api/menu/page', params)

// 删除
export const removeItem = id => request.get(`/masterdata-api/menu/delete/${id}`)

// 新增或更新菜单
export const updateAndAddMenu = params =>
  request.post('/masterdata-api/menu/add', params)
